import { useState, useEffect } from 'react';
import { modelsApi } from '../api/models';

export interface ModelUsage {
  current: number;
  limit: number;
  remaining: number;
  allowed: boolean;
  reset_period: string;
}

export interface AvailableModel {
  model_id: string;
  name: string;
  display_name: string;
  description: string | null;
  provider: string;
  model_identifier: string;
  capabilities: Record<string, any>;
  credit_cost: number;
  speed_rating: number | null;
  quality_rating: number | null;
  is_default: boolean;
  badge_text: string | null;
  icon: string | null;
  usage: ModelUsage;
}

export const useModels = () => {
  const [availableModels, setAvailableModels] = useState<AvailableModel[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchAvailableModels();
  }, []);

  const fetchAvailableModels = async () => {
    try {
      setLoading(true);
      const models = await modelsApi.getAvailableModels();
      setAvailableModels(models);
      setError(null);
    } catch (err: any) {
      setError(err.message || 'Failed to load models');
      console.error('Error fetching models:', err);
    } finally {
      setLoading(false);
    }
  };

  const checkModelAccess = async (modelId: string) => {
    try {
      return await modelsApi.checkModelAccess(modelId);
    } catch (err: any) {
      console.error('Error checking model access:', err);
      return { allowed: false, reason: 'Error checking access' };
    }
  };

  return {
    availableModels,
    loading,
    error,
    refetch: fetchAvailableModels,
    checkModelAccess,
  };
};
